import DayJsUtils from "@date-io/dayjs";
import { CssBaseline, Paper, ThemeProvider } from "@material-ui/core";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import ClearCache from "react-clear-cache";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import MuiStylesApp from "~/components/app/MuiStylesApp";
import MuiThemeApp from "~/components/app/MuiThemeApp";
import dayjs from "~/config/dayjs";
import authService from "~/services/authService";
import Routers from "~/views/app/routers/Routers";
import { Firebase } from "~/services/firebase";
import { mixpanelInitialize } from "~/utils/mixpanel";
import authAction from "~/store/actions/authAction";
import { setMe } from "~/store/actions/meAction";
import { store } from "~/store";
import "./App.css";
import { WhatsAppAuthProvider } from "~/contexts/WhatsAppAuthContext";
import useAuthCodeFlow from "~/hooks/useAuthCodeFlow";
import { verifyBookingAuthCode } from "~/services/loginService";


const App = () => {
	const dispatch = useDispatch();
	const classes = MuiStylesApp();

	// Auto-login via link mágico (auth_code / token na URL).
	// Seta a flag síncrona + executa o fluxo de verificação no mount.
	const isBookingConfirmation = window.location.pathname.includes("/booking-confirmation");
	useAuthCodeFlow({
		verifyFn: isBookingConfirmation ? verifyBookingAuthCode : undefined,
	});

	useEffect(() => {
		return Firebase.onIdTokenChanged(async (user) => {
			if (!user) {
				const reduxUser = store.getState().auth?.user;
				const alreadyAuthenticated = reduxUser && !reduxUser.isAnonymous;
				if (!window.__PRIT_CODE_LOGIN_IN_PROGRESS__ && !alreadyAuthenticated) {
					await authService.authenticateAnonymousUser();
				}
			} else {
				dispatch(authAction.setUser(user));
				if (!user.isAnonymous) {
					const freshToken = await user.getIdToken();
					dispatch(setMe(freshToken));
				}
			}
		});
	}, [dispatch]);

	useEffect(() => {
		mixpanelInitialize();
		const handle = setInterval(async () => {
			const user = Firebase.currentUser;
			if (user) await user.getIdToken(true);
		}, 10 * 60 * 1000);

		(function (c, l, a, r, i, t, y) {
			c[a] =
				c[a] ||
				function () {
					(c[a].q = c[a].q || []).push(arguments);
				};
			t = l.createElement(r);
			t.async = 1;
			t.src = "https://www.clarity.ms/tag/" + i;
			y = l.getElementsByTagName(r)[0];
			y.parentNode.insertBefore(t, y);
		})(window, document, "clarity", "script", process.env.REACT_APP_CLARITY_ID);

		return () => clearInterval(handle);
	}, []);

	return (
		<ClearCache>
			{({ isLatestVersion, emptyCacheStorage }) => {
				if (!isLatestVersion) {
					emptyCacheStorage();
				}
				return (
					<WhatsAppAuthProvider>
						<ThemeProvider theme={MuiThemeApp}>
							<CssBaseline />
							<Paper className={classes.mainPaper}>
								<MuiPickersUtilsProvider libInstance={dayjs} utils={DayJsUtils}>
									<Routers />
								</MuiPickersUtilsProvider>
							</Paper>
						</ThemeProvider>
					</WhatsAppAuthProvider>
				);
			}}
		</ClearCache>
	);
};

export default App;
